import React, { CSSProperties, FC } from 'react';
import { getFullVelocityUrl } from '../../../Helper';

const velocityUrl: string = getFullVelocityUrl();

type IconProps = {
	elementStyle?: CSSProperties;
	title?: string;
};

// Menu Items
export const File: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='16' height='19' viewBox='0 0 16 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='13' height='16' fill='white' />
		<path d='M3 5H10' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M3 8H10' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M3 11H10' stroke='#E9E9E9' strokeLinecap='round' />
		<path
			d='M11.5447 19H9.52068C9.51816 18.9915 9.515 18.9829 9.51342 18.9742C9.46577 18.692 9.41827 18.4099 9.37062 18.1277C9.35184 18.0169 9.3329 17.906 9.31349 17.7927C8.97644 17.7013 8.65848 17.5672 8.35125 17.4016C8.00677 17.6472 7.6642 17.8915 7.33219 18.1282C6.85406 17.6486 6.38146 17.1747 5.90712 16.6989C6.1454 16.3627 6.38825 16.0201 6.63189 15.6763C6.46872 15.3749 6.33018 15.0656 6.24165 14.7338C5.82759 14.6644 5.41685 14.5955 5.00815 14.5271C4.99616 14.4673 4.99805 12.5457 5.00957 12.5025C5.41905 12.4415 5.82964 12.3802 6.24165 12.319C6.33302 11.9792 6.46699 11.6604 6.63173 11.3531C6.38683 11.0151 6.14366 10.6797 5.89829 10.3412C6.38083 9.86474 6.86101 9.39083 7.34182 8.91614C7.36154 8.92944 7.37622 8.93926 7.39073 8.94939C7.69418 9.16378 7.9981 9.37738 8.30028 9.59351C8.33736 9.61995 8.36418 9.62311 8.40474 9.60126C8.67662 9.45369 8.95861 9.32908 9.25763 9.24722C9.28493 9.23978 9.2933 9.22569 9.29756 9.1994C9.35389 8.85518 9.41117 8.51127 9.46845 8.1672C9.47776 8.11147 9.48802 8.05573 9.49796 8H11.5154C11.584 8.40487 11.6524 8.80799 11.7207 9.21065C11.7335 9.21587 11.7431 9.22062 11.7532 9.22363C12.0519 9.31198 12.337 9.43343 12.6115 9.5802C12.6481 9.59984 12.6724 9.59905 12.7069 9.57498C13.0187 9.35727 13.3321 9.14161 13.6452 8.92548C13.6608 8.91471 13.6772 8.90506 13.6944 8.89397C14.1688 9.37753 14.6403 9.85825 15.114 10.3412C14.8676 10.6811 14.6237 11.0177 14.3804 11.3534C14.5546 11.6538 14.681 11.9678 14.7709 12.2962C15.184 12.365 15.5921 12.4331 16 12.5012V14.5314C15.9841 14.5325 15.968 14.5327 15.9522 14.5351C15.6278 14.584 15.3033 14.6332 14.9791 14.6825C14.9177 14.6918 14.8563 14.7018 14.8031 14.7102C14.7424 14.8766 14.6897 15.0382 14.6243 15.1945C14.559 15.3508 14.481 15.5019 14.407 15.6588C14.6485 15.9995 14.8919 16.3433 15.1321 16.6821C14.6559 17.1596 14.1842 17.6326 13.7088 18.1094C13.3703 17.868 13.0276 17.6237 12.6853 17.3796C12.6713 17.3865 12.6599 17.3916 12.6489 17.3975C12.3705 17.5441 12.0833 17.6698 11.7808 17.7577C11.7485 17.767 11.7412 17.7851 11.7363 17.8144C11.6812 18.1496 11.6248 18.4846 11.5692 18.8198C11.5593 18.8797 11.553 18.94 11.5449 19H11.5447ZM10.5045 15.6298C11.673 15.6304 12.6138 14.6902 12.6151 13.5201C12.6164 12.3573 11.6688 11.4022 10.5099 11.3985C9.35405 11.3949 8.39764 12.3513 8.39653 13.5119C8.39543 14.6861 9.33385 15.629 10.5044 15.6298H10.5045Z'
			fill='#656565'
		/>
	</svg>
);

export const Drawing: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='23' height='15' fill='white' fillOpacity='0.36' stroke='white' />
	</svg>
);

export const Selection: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} version='1.1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 50 50'>
		<g id='Layer_1' className='st0' style={{ display: 'none' }}>
			<g className='st1' style={{ display: 'inline' }}>
				<path
					d='M40.34,31.81c0.22,0.14,0.4,0.21,0.53,0.34c2.56,2.56,5.12,5.12,7.68,7.69c0.93,0.93,0.93,1.78,0,2.71
		   c-2.02,2.03-4.04,4.05-6.07,6.08c-0.9,0.9-1.76,0.89-2.67-0.01c-2.56-2.56-5.12-5.13-7.67-7.69c-0.13-0.13-0.22-0.3-0.36-0.5
		   c-0.19,0.27-0.3,0.41-0.4,0.56c-1.63,2.45-3.27,4.9-4.89,7.36c-0.41,0.63-0.94,1.03-1.71,0.92c-0.79-0.11-1.19-0.64-1.42-1.39
		   C20.19,37.25,17.01,26.62,13.82,16c-0.21-0.7-0.19-1.34,0.35-1.87c0.53-0.52,1.15-0.54,1.83-0.34c10.53,3.17,21.07,6.34,31.61,9.5
		   c0.14,0.04,0.29,0.09,0.43,0.14c0.65,0.21,1.06,0.65,1.17,1.33c0.1,0.68-0.17,1.22-0.74,1.61c-1.13,0.76-2.26,1.52-3.4,2.27
		   C43.55,29.66,42.02,30.68,40.34,31.81z M25.55,43.87c0.15-0.21,0.25-0.34,0.34-0.48c1.35-2.03,2.7-4.07,4.06-6.1
		   c0.8-1.2,1.83-1.31,2.85-0.29c2.66,2.66,5.31,5.32,7.96,7.98c0.13,0.13,0.17,0.33,0.19,0.37c1.53-1.51,2.91-2.87,4.33-4.27
		   c-0.11-0.1-0.26-0.22-0.39-0.35c-2.64-2.65-5.28-5.29-7.93-7.94c-0.99-0.99-0.88-2.04,0.28-2.82c2.03-1.36,4.06-2.71,6.09-4.07
		   c0.15-0.1,0.29-0.2,0.51-0.36c-8.75-2.63-17.41-5.23-26.13-7.86C20.33,26.46,22.93,35.11,25.55,43.87z'
				/>
				<path
					d='M13.68,4.76c0-0.78-0.01-1.55,0-2.33c0.01-0.99,0.68-1.71,1.6-1.72c0.92-0.01,1.62,0.71,1.63,1.69
		   c0.01,1.57,0.01,3.14,0,4.7c-0.01,0.98-0.71,1.7-1.62,1.7c-0.92-0.01-1.6-0.73-1.6-1.72C13.68,6.31,13.68,5.53,13.68,4.76z'
				/>
				<path
					d='M4.81,13.66c0.77,0,1.55-0.01,2.32,0c0.98,0.01,1.7,0.7,1.7,1.62c0,0.92-0.72,1.61-1.7,1.62c-1.56,0.01-3.13,0.01-4.69,0
		   c-0.97-0.01-1.69-0.72-1.68-1.64c0.01-0.9,0.72-1.58,1.68-1.59C3.23,13.65,4.02,13.66,4.81,13.66z'
				/>
				<path
					d='M5.84,3.93c0.19,0.1,0.61,0.23,0.9,0.5c1.1,1.04,2.16,2.13,3.22,3.21c0.67,0.68,0.65,1.67,0,2.31
		   c-0.64,0.62-1.61,0.63-2.27-0.02C6.6,8.87,5.52,7.78,4.45,6.68c-0.49-0.51-0.6-1.13-0.31-1.78C4.42,4.28,4.94,3.97,5.84,3.93z'
				/>
				<path
					d='M26.63,5.79c-0.11,0.2-0.24,0.62-0.51,0.91c-1.04,1.1-2.12,2.17-3.2,3.23c-0.68,0.67-1.67,0.66-2.3,0.01
		   c-0.62-0.64-0.63-1.61,0.02-2.27c1.07-1.1,2.15-2.18,3.25-3.25c0.51-0.5,1.12-0.6,1.77-0.31C26.28,4.37,26.58,4.89,26.63,5.79z'
				/>
				<path
					d='M5.78,26.63c-0.84-0.05-1.35-0.34-1.63-0.94c-0.28-0.6-0.24-1.22,0.21-1.7c1.13-1.18,2.28-2.34,3.46-3.47
		   c0.6-0.57,1.56-0.49,2.15,0.1c0.59,0.59,0.68,1.55,0.1,2.16c-1.12,1.19-2.28,2.34-3.46,3.46C6.37,26.47,5.97,26.54,5.78,26.63z'
				/>
			</g>
		</g>
		<g id='Layer_2'>
			<g>
				<path
					className='st2'
					fill='#FFF'
					d='M27.34,19c0.21,0.13,0.39,0.21,0.52,0.33c2.49,2.49,16.48,16.49,18.97,18.98c0.9,0.9,0.9,1.73,0,2.64
		   c-1.97,1.97-3.94,3.95-5.91,5.92c-0.87,0.88-1.71,0.87-2.6-0.01c-2.49-2.49-16.48-16.49-18.97-18.99
		   c-0.13-0.13-0.21-0.29-0.35-0.49c-0.19,0.26-0.29,0.4-0.39,0.55c-1.59,2.39-3.18,4.77-4.76,7.17c-0.4,0.61-0.91,1-1.67,0.9
		   c-0.77-0.11-1.16-0.63-1.38-1.35C7.73,24.3,4.63,13.96,1.53,3.62c-0.2-0.68-0.18-1.3,0.34-1.82c0.51-0.5,1.12-0.53,1.78-0.33
		   c10.25,3.09,20.51,6.17,30.77,9.25c0.14,0.04,0.28,0.09,0.42,0.14c0.64,0.2,1.04,0.64,1.13,1.29c0.1,0.66-0.17,1.19-0.72,1.56
		   c-1.1,0.74-2.2,1.48-3.31,2.21C30.46,16.92,28.98,17.91,27.34,19z'
				/>
			</g>
		</g>
	</svg>
);

export const Text: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M12.46 3.66012H11.86L10.92 1.36012L7.7 1.32012V13.3401L9.56 13.5201V14.0001H3.18V13.5201L5.04 13.3401V1.32012L1.82 1.36012L0.88 3.66012H0.3V0.640121L6.38 0.600122L12.46 0.640121V3.66012Z'
			fill='white'
		/>
	</svg>
);

// MapDirectory
export const MapDirectoryIcon: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='39' height='30' viewBox='0 0 39 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M28.5792 0C28.8893 0.154962 29 0.398473 29 0.752672C29 9.91756 29 19.0603 29 28.2252C29 28.8229 28.8228 29 28.1805 29C24.7251 29 21.2476 29 17.7923 29C12.2105 29 6.62881 29 1.04709 29C0.93634 29 0.847741 29 0.736993 29C0.2054 29 0.00605326 28.8008 0.00605326 28.2473C0.00605326 28.2031 0.00605326 28.1588 0.00605326 28.1145C0.00605326 19.0382 0.00605326 9.96183 0.00605326 0.885496C-0.0160964 0.50916 0.00605293 0.199237 0.360448 0H28.5792ZM1.15784 1.17328V13.9023H10.3943V10.471C10.1728 10.471 9.97341 10.471 9.75192 10.4267C9.41967 10.3824 9.24247 10.1611 9.26462 9.85114C9.26462 9.54122 9.46397 9.31985 9.79622 9.29771C10.5936 9.29771 11.4131 9.29771 12.2105 9.29771C12.5428 9.29771 12.72 9.54122 12.7421 9.85114C12.7421 10.1611 12.5649 10.3824 12.2327 10.4267C12.0333 10.4489 11.8118 10.4489 11.5903 10.471C11.5903 11.755 11.5903 12.9947 11.5903 14.2344C11.5903 14.9427 11.4353 15.0977 10.7265 15.0977C7.66985 15.0977 4.63534 15.0977 1.57868 15.0977H1.15784V18.5733H1.55653C3.48355 18.5733 5.43273 18.5733 7.35975 18.5733C7.91349 18.5733 8.11284 18.7947 8.09069 19.3038C8.00209 22.5802 5.94217 25.3252 2.84121 26.3214C2.28747 26.4985 1.73373 26.587 1.15784 26.7198V27.8267H13.8939V27.4061C13.8939 24.329 13.8939 21.274 13.8939 18.1969C13.8939 17.5771 14.0711 17.4 14.6913 17.4C15.8431 17.4 16.9949 17.4 18.1467 17.4H18.501C18.501 17.1565 18.501 16.9573 18.5453 16.758C18.5896 16.426 18.8111 16.2489 19.1212 16.2489C19.4313 16.2489 19.6528 16.4481 19.675 16.7802C19.675 17.5771 19.675 18.3962 19.675 19.1931C19.675 19.5252 19.4535 19.7023 19.1212 19.7244C18.8111 19.7244 18.5896 19.5473 18.5453 19.2153C18.5232 19.016 18.5232 18.7947 18.501 18.5954H15.0678V27.8267H27.7818V18.5954H24.3264C24.3264 18.7947 24.3264 18.9496 24.3264 19.1267C24.3043 19.5252 24.0828 19.7244 23.7284 19.7244C23.374 19.7244 23.1746 19.5031 23.1746 19.1046C23.1746 18.374 23.1746 17.6435 23.1746 16.8908C23.1746 16.4924 23.3961 16.271 23.7284 16.271C24.0606 16.271 24.2821 16.4924 24.3264 16.8687C24.3264 17.0458 24.3264 17.2229 24.3264 17.4H27.7818V8.14656H25.4782C25.4782 8.3458 25.4782 8.5229 25.4782 8.72214C25.4339 9.09847 25.2346 9.29771 24.8802 9.27557C24.5479 9.27557 24.3264 9.0542 24.3264 8.67786C24.3264 7.92519 24.3264 7.17252 24.3264 6.44198C24.3264 6.04351 24.5479 5.82214 24.9023 5.82214C25.2567 5.82214 25.456 6.04351 25.4782 6.44198C25.4782 6.59695 25.4782 6.77405 25.4782 6.95114H27.7818V1.17328H17.9695V6.92901H19.6528C19.6528 6.6855 19.6528 6.48626 19.6971 6.26488C19.7414 5.95496 19.9629 5.77786 20.273 5.8C20.561 5.8 20.8046 5.95496 20.8046 6.26488C20.8046 7.10611 20.8046 7.96947 20.8046 8.81069C20.8046 9.12061 20.561 9.25343 20.273 9.25343C19.9629 9.25343 19.7636 9.09847 19.7193 8.78855C19.6971 8.58931 19.675 8.36794 19.675 8.10229C19.5421 8.10229 19.4535 8.10229 19.3427 8.10229C18.789 8.10229 18.2574 8.10229 17.7037 8.10229C16.9284 8.10229 16.8177 7.9916 16.8177 7.21679C16.8177 5.33511 16.8177 3.4313 16.8177 1.54962V1.17328H11.6125V4.62672C11.8118 4.62672 11.989 4.62672 12.1884 4.62672C12.5428 4.67099 12.7643 4.89237 12.7421 5.22443C12.7421 5.55649 12.5206 5.77786 12.1441 5.77786C11.391 5.77786 10.6379 5.77786 9.90696 5.77786C9.50827 5.77786 9.28677 5.55649 9.28677 5.22443C9.28677 4.87023 9.48612 4.67099 9.88482 4.62672C10.062 4.62672 10.2392 4.62672 10.3943 4.62672V1.17328H1.15784ZM1.15784 25.4802C4.36954 25.3031 6.82816 22.3809 6.89461 19.7466H1.15784V25.4802Z'
			fill='white'
		/>
		<path
			d='M14 29H33V15.9846C33 14.2123 31.6961 13.7692 31.0441 13.7692H22.9412V12.6615C22.9412 11.3323 21.451 11 20.7059 11H15.9559C14.3912 11 14 12.1077 14 12.6615V29Z'
			fill='#FAD723'
			stroke='#FAD723'
		/>
		<path
			d='M20.1684 19.0147L14 29H33.0659L37.8323 21.297C38.5052 19.2429 36.9912 18.9196 36.15 19.0147L20.1684 19.0147Z'
			fill='#F5B400'
			stroke='#F5B400'
		/>
	</svg>
);

export const MapDirectoryNoFolderIcon: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='39' height='30' viewBox='0 0 39 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M28.5792 0C28.8893 0.154962 29 0.398473 29 0.752672C29 9.91756 29 19.0603 29 28.2252C29 28.8229 28.8228 29 28.1805 29C24.7251 29 21.2476 29 17.7923 29C12.2105 29 6.62881 29 1.04709 29C0.93634 29 0.847741 29 0.736993 29C0.2054 29 0.00605326 28.8008 0.00605326 28.2473C0.00605326 28.2031 0.00605326 28.1588 0.00605326 28.1145C0.00605326 19.0382 0.00605326 9.96183 0.00605326 0.885496C-0.0160964 0.50916 0.00605293 0.199237 0.360448 0H28.5792ZM1.15784 1.17328V13.9023H10.3943V10.471C10.1728 10.471 9.97341 10.471 9.75192 10.4267C9.41967 10.3824 9.24247 10.1611 9.26462 9.85114C9.26462 9.54122 9.46397 9.31985 9.79622 9.29771C10.5936 9.29771 11.4131 9.29771 12.2105 9.29771C12.5428 9.29771 12.72 9.54122 12.7421 9.85114C12.7421 10.1611 12.5649 10.3824 12.2327 10.4267C12.0333 10.4489 11.8118 10.4489 11.5903 10.471C11.5903 11.755 11.5903 12.9947 11.5903 14.2344C11.5903 14.9427 11.4353 15.0977 10.7265 15.0977C7.66985 15.0977 4.63534 15.0977 1.57868 15.0977H1.15784V18.5733H1.55653C3.48355 18.5733 5.43273 18.5733 7.35975 18.5733C7.91349 18.5733 8.11284 18.7947 8.09069 19.3038C8.00209 22.5802 5.94217 25.3252 2.84121 26.3214C2.28747 26.4985 1.73373 26.587 1.15784 26.7198V27.8267H13.8939V27.4061C13.8939 24.329 13.8939 21.274 13.8939 18.1969C13.8939 17.5771 14.0711 17.4 14.6913 17.4C15.8431 17.4 16.9949 17.4 18.1467 17.4H18.501C18.501 17.1565 18.501 16.9573 18.5453 16.758C18.5896 16.426 18.8111 16.2489 19.1212 16.2489C19.4313 16.2489 19.6528 16.4481 19.675 16.7802C19.675 17.5771 19.675 18.3962 19.675 19.1931C19.675 19.5252 19.4535 19.7023 19.1212 19.7244C18.8111 19.7244 18.5896 19.5473 18.5453 19.2153C18.5232 19.016 18.5232 18.7947 18.501 18.5954H15.0678V27.8267H27.7818V18.5954H24.3264C24.3264 18.7947 24.3264 18.9496 24.3264 19.1267C24.3043 19.5252 24.0828 19.7244 23.7284 19.7244C23.374 19.7244 23.1746 19.5031 23.1746 19.1046C23.1746 18.374 23.1746 17.6435 23.1746 16.8908C23.1746 16.4924 23.3961 16.271 23.7284 16.271C24.0606 16.271 24.2821 16.4924 24.3264 16.8687C24.3264 17.0458 24.3264 17.2229 24.3264 17.4H27.7818V8.14656H25.4782C25.4782 8.3458 25.4782 8.5229 25.4782 8.72214C25.4339 9.09847 25.2346 9.29771 24.8802 9.27557C24.5479 9.27557 24.3264 9.0542 24.3264 8.67786C24.3264 7.92519 24.3264 7.17252 24.3264 6.44198C24.3264 6.04351 24.5479 5.82214 24.9023 5.82214C25.2567 5.82214 25.456 6.04351 25.4782 6.44198C25.4782 6.59695 25.4782 6.77405 25.4782 6.95114H27.7818V1.17328H17.9695V6.92901H19.6528C19.6528 6.6855 19.6528 6.48626 19.6971 6.26488C19.7414 5.95496 19.9629 5.77786 20.273 5.8C20.561 5.8 20.8046 5.95496 20.8046 6.26488C20.8046 7.10611 20.8046 7.96947 20.8046 8.81069C20.8046 9.12061 20.561 9.25343 20.273 9.25343C19.9629 9.25343 19.7636 9.09847 19.7193 8.78855C19.6971 8.58931 19.675 8.36794 19.675 8.10229C19.5421 8.10229 19.4535 8.10229 19.3427 8.10229C18.789 8.10229 18.2574 8.10229 17.7037 8.10229C16.9284 8.10229 16.8177 7.9916 16.8177 7.21679C16.8177 5.33511 16.8177 3.4313 16.8177 1.54962V1.17328H11.6125V4.62672C11.8118 4.62672 11.989 4.62672 12.1884 4.62672C12.5428 4.67099 12.7643 4.89237 12.7421 5.22443C12.7421 5.55649 12.5206 5.77786 12.1441 5.77786C11.391 5.77786 10.6379 5.77786 9.90696 5.77786C9.50827 5.77786 9.28677 5.55649 9.28677 5.22443C9.28677 4.87023 9.48612 4.67099 9.88482 4.62672C10.062 4.62672 10.2392 4.62672 10.3943 4.62672V1.17328H1.15784ZM1.15784 25.4802C4.36954 25.3031 6.82816 22.3809 6.89461 19.7466H1.15784V25.4802Z'
			fill='white'
		/>
	</svg>
);

export const OpenFolder: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='26' height='20' viewBox='0 0 26 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M1 19.0143H19.8457V5.98856C19.8457 4.21485 18.5523 3.77142 17.9057 3.77142H9.86856V2.66285C9.86856 1.33257 8.39046 1 7.65142 1H2.94C1.388 1 1 2.10857 1 2.66285V19.0143Z'
			fill='#FAD723'
			stroke='#FAD723'
		/>
		<path
			d='M7.37423 9.3143L1.2771 19.0143H20.1228L24.8342 11.5314C25.4993 9.53601 24.0028 9.22192 23.1714 9.3143L7.37423 9.3143Z'
			fill='#F5B400'
			stroke='#F5B400'
		/>
	</svg>
);

export const WarningSign: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='21' height='18' viewBox='0 0 21 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g clipPath='url(#clip0_743_532)'>
			<path
				d='M0.132516 16.6128L9.79939 0.413302C10.13 -0.137767 10.875 -0.137767 11.2056 0.413302L20.868 16.6128C21.2251 17.2114 20.8284 18 20.1672 18H0.837806C0.176597 18 -0.220128 17.2114 0.136924 16.6128H0.132516Z'
				fill='#FA8C16'
			/>
			<path d='M8.31812 5.79102H12.6821L11.3156 12.7744H9.68461L8.31812 5.79102Z' fill='white' />
			<path d='M11.3597 13.582H9.59644V15.4823H11.3597V13.582Z' fill='white' />
		</g>
		<defs>
			<clipPath id='clip0_743_532'>
				<rect width='21' height='18' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

export const SortDefault: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='20' height='15' viewBox='0 0 9 18' xmlns='http://www.w3.org/2000/svg'>
		<g id='g6217-0' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,0.02509567,7.0659856)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9'
				style={{ fill: '#475376' }}
			/>
		</g>
		<g id='g6217-0-1' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,0.02509617,11.017364)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-0'
				style={{ fill: '#475376' }}
			/>
		</g>
	</svg>
);

export const SortAsc: FC<IconProps> = ({ elementStyle }) => (
	<svg viewBox='0 0 9 18' width='20' height='15' xmlns='http://www.w3.org/2000/svg'>
		<g id='g6217-0' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,0.02509567,7.0659856)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-5' style={{ fill: '#475376', opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,0.04795291,7.0740644)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-5-0' style={{ fill: '#475376', opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,0.01366707,7.0969214)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2-4'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-1' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,0.02509617,11.017364)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-0'
				style={{ fill: '#475376' }}
			/>
		</g>
		<g id='layer8' />
		<g id='g17959' transform='translate(93)'>
			<path d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z' id='path17957' />
		</g>
		<g id='g6217-0-5-6' style={{ fill: '#475376', opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,-0.00919,7.0854928)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2-2'
				style={{ fill: '#475376', opacity: 1 }}
			/>
		</g>
	</svg>
);

export const SortDesc: FC<IconProps> = ({ elementStyle }) => (
	<svg viewBox='0 0 9 18' width='20' height='15' xmlns='http://www.w3.org/2000/svg'>
		<g id='g6217-0' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,0.02509567,10.984014)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-5' style={{ fill: '#475376', opacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,0.04795291,10.975936)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-5-0' style={{ fill: '#475376', fillOpacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,0.01366707,10.953079)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2-4'
				style={{ fill: '#475376', fillOpacity: 1 }}
			/>
		</g>
		<g id='g6217-0-1' style={{ opacity: 0.5 }} transform='matrix(0.38620419,0,0,-0.38620419,0.02509617,7.032636)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-0'
				style={{ fill: '#475376' }}
			/>
		</g>
		<g id='layer8' />
		<g id='g17959' transform='matrix(1,0,0,-1,93,18.05)'>
			<path d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z' id='path17957' />
		</g>
		<g id='g6217-0-5-6' style={{ fill: '#475376', opacity: 0.5 }} transform='matrix(0.38620419,0,0,0.38620419,-0.00919,10.964507)'>
			<path
				d='m 20.9,1.4 -9.7,16.2 c -0.3,0.6 -1.1,0.6 -1.4,0 L 0.1,1.4 C -0.2,0.8 0.2,0 0.8,0 h 19.3 c 0.7,0 1.1,0.8 0.8,1.4 z'
				id='path6215-9-2-2'
				style={{ fill: '#475376', opacity: 1 }}
			/>
		</g>
	</svg>
);

// SubMenu Items
// File Menu
export const Copy: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='17' height='19' viewBox='0 0 17 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect y='3' width='13' height='16' fill='#BEBEBE' />
		<rect x='4' width='13' height='16' fill='white' />
		<path d='M7 5H14' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M7 8H14' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M7 11H14' stroke='#E9E9E9' strokeLinecap='round' />
	</svg>
);

export const Cut: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='19' viewBox='0 0 15 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='12' cy='16' r='2.5' stroke='#656565' />
		<path d='M9.5 16.5L7 11' stroke='#656565' strokeLinecap='round' />
		<path
			d='M9 13.9291L2.16675 0.834048C0.458433 -2.01254 -0.680443 3.11155 0.458432 5.95817C1.59731 8.80479 3.07785 10.3991 4.4445 12.221C5.81115 14.043 8.05094 14.1189 9 13.9291Z'
			fill='#656565'
		/>
		<circle cx='3' cy='3' r='2.5' transform='matrix(-1 0 0 1 6 13)' stroke='#BEBEBE' />
		<path d='M5.5 16.5L8 11' stroke='#BEBEBE' strokeLinecap='round' />
		<path
			d='M6 13.9291L12.8333 0.834048C14.5416 -2.01254 15.6804 3.11155 14.5416 5.95817C13.4027 8.80479 11.9222 10.3991 10.5555 12.221C9.18885 14.043 6.94906 14.1189 6 13.9291Z'
			fill='#BEBEBE'
		/>
	</svg>
);

export const Delete: FC<IconProps> = ({ elementStyle }) => (
	<svg
		style={elementStyle}
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'>
		<rect width='18' height='18' fill='url(#pattern0)' />
		<defs>
			<pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
				<use xlinkHref='#image0_1_3482' transform='scale(0.0078125)' />
			</pattern>
			<image
				id='image0_1_3482'
				width='128'
				height='128'
				xlinkHref='data:image/png;base64,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'
			/>
		</defs>
	</svg>
);

export const ExportFile: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='13' height='16' viewBox='0 0 13 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect y='7' width='13' height='9' rx='3' fill='#BEBEBE' />
		<path d='M6.5 11.0455L6.5 1.59099' stroke='black' strokeLinecap='round' />
		<path d='M10.6364 5.72729L6.49999 1.00002L2.36363 5.7273' stroke='black' strokeLinecap='round' />
	</svg>
);

export const ImportFile: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='13' height='16' viewBox='0 0 13 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect y='7' width='13' height='9' rx='3' fill='#BEBEBE' />
		<path d='M6.5 1V10.4545' stroke='black' strokeLinecap='round' />
		<path d='M2.36365 6.31824L6.50001 11.0455L10.6364 6.31824' stroke='black' strokeLinecap='round' />
	</svg>
);

export const MapDirectory: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='23' height='18' viewBox='0 0 23 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M16.7533 0C16.9351 0.0908397 17 0.233588 17 0.441221C17 5.81374 17 11.1733 17 16.5458C17 16.8962 16.8961 17 16.5196 17C14.494 17 12.4555 17 10.4299 17C7.1579 17 3.88585 17 0.61381 17C0.548889 17 0.496952 17 0.43203 17C0.120407 17 0.00354846 16.8832 0.00354846 16.5588C0.00354846 16.5328 0.00354846 16.5069 0.00354846 16.4809C0.00354846 11.1603 0.00354846 5.83969 0.00354846 0.519084C-0.00943584 0.298473 0.00354827 0.116794 0.211297 0H16.7533ZM0.678732 0.687786V8.14962H6.09319V6.13817C5.96334 6.13817 5.84648 6.13817 5.71664 6.11221C5.52188 6.08626 5.418 5.95649 5.43099 5.77481C5.43099 5.59313 5.54785 5.46336 5.74261 5.45038C6.21004 5.45038 6.69046 5.45038 7.1579 5.45038C7.35266 5.45038 7.45654 5.59313 7.46952 5.77481C7.46952 5.95649 7.36565 6.08626 7.17088 6.11221C7.05402 6.12519 6.92418 6.12519 6.79434 6.13817C6.79434 6.89084 6.79434 7.61756 6.79434 8.34427C6.79434 8.75954 6.70345 8.85038 6.28795 8.85038C4.49612 8.85038 2.71727 8.85038 0.925434 8.85038H0.678732V10.8878H0.912449C2.04208 10.8878 3.1847 10.8878 4.31434 10.8878C4.63894 10.8878 4.7558 11.0176 4.74282 11.316C4.69088 13.2366 3.48334 14.8458 1.66554 15.4298C1.34093 15.5336 1.01632 15.5855 0.678732 15.6634V16.3122H8.1447V16.0656C8.1447 14.2618 8.1447 12.471 8.1447 10.6672C8.1447 10.3038 8.24858 10.2 8.61214 10.2C9.28732 10.2 9.96251 10.2 10.6377 10.2H10.8454C10.8454 10.0573 10.8454 9.94046 10.8714 9.82366C10.8974 9.62901 11.0272 9.52519 11.209 9.52519C11.3908 9.52519 11.5206 9.64198 11.5336 9.83664C11.5336 10.3038 11.5336 10.784 11.5336 11.2511C11.5336 11.4458 11.4038 11.5496 11.209 11.5626C11.0272 11.5626 10.8974 11.4588 10.8714 11.2641C10.8584 11.1473 10.8584 11.0176 10.8454 10.9008H8.83287V16.3122H16.2859V10.9008H14.2603C14.2603 11.0176 14.2603 11.1084 14.2603 11.2122C14.2473 11.4458 14.1175 11.5626 13.9097 11.5626C13.702 11.5626 13.5851 11.4328 13.5851 11.1992C13.5851 10.771 13.5851 10.3427 13.5851 9.90153C13.5851 9.66794 13.715 9.53817 13.9097 9.53817C14.1045 9.53817 14.2343 9.66794 14.2603 9.88855C14.2603 9.99237 14.2603 10.0962 14.2603 10.2H16.2859V4.77557H14.9355C14.9355 4.89237 14.9355 4.99618 14.9355 5.11298C14.9095 5.33359 14.7927 5.45038 14.5849 5.4374C14.3902 5.4374 14.2603 5.30763 14.2603 5.08702C14.2603 4.6458 14.2603 4.20458 14.2603 3.77634C14.2603 3.54275 14.3902 3.41298 14.5979 3.41298C14.8057 3.41298 14.9225 3.54275 14.9355 3.77634C14.9355 3.86718 14.9355 3.97099 14.9355 4.07481H16.2859V0.687786H10.5338V4.06183H11.5206C11.5206 3.91908 11.5206 3.80229 11.5466 3.67252C11.5726 3.49084 11.7024 3.38702 11.8842 3.4C12.053 3.4 12.1958 3.49084 12.1958 3.67252C12.1958 4.16565 12.1958 4.67176 12.1958 5.16489C12.1958 5.34656 12.053 5.42443 11.8842 5.42443C11.7024 5.42443 11.5855 5.33359 11.5596 5.15191C11.5466 5.03511 11.5336 4.90534 11.5336 4.74962C11.4557 4.74962 11.4038 4.74962 11.3388 4.74962C11.0142 4.74962 10.7026 4.74962 10.378 4.74962C9.92355 4.74962 9.85863 4.68473 9.85863 4.23053C9.85863 3.12748 9.85863 2.01145 9.85863 0.908397V0.687786H6.80732V2.71221C6.92418 2.71221 7.02806 2.71221 7.14491 2.71221C7.35266 2.73817 7.48251 2.86794 7.46952 3.0626C7.46952 3.25725 7.33968 3.38702 7.11895 3.38702C6.67748 3.38702 6.23601 3.38702 5.80753 3.38702C5.57381 3.38702 5.44397 3.25725 5.44397 3.0626C5.44397 2.85496 5.56083 2.73817 5.79455 2.71221C5.89842 2.71221 6.0023 2.71221 6.09319 2.71221V0.687786H0.678732ZM0.678732 14.9366C2.56146 14.8328 4.00271 13.1198 4.04167 11.5756H0.678732V14.9366Z'
			fill='#1D1D1D'
		/>
		<path
			d='M8 17H19V9.76923C19 8.78462 18.2451 8.53846 17.8676 8.53846H13.1765V7.92308C13.1765 7.18462 12.3137 7 11.8824 7H9.13235C8.22647 7 8 7.61538 8 7.92308V17Z'
			fill='#656565'
			stroke='#656565'
		/>
		<path
			d='M11.5982 11.0088L8 17H19.1217L21.9022 12.3782C22.2947 11.1457 21.4115 10.9517 20.9209 11.0088L11.5982 11.0088Z'
			fill='#BEBEBE'
			stroke='#BEBEBE'
		/>
	</svg>
);

export const Paste: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='17' height='19' viewBox='0 0 17 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='2.5' width='13' height='14' rx='1.5' fill='#656565' stroke='#656565' />
		<path d='M4.5 1.5H3V5H11V1.5H9C9 0.3 7.66667 0 7 0C5 0 4.5 1 4.5 1.5Z' fill='#BEBEBE' />
		<rect x='9' y='9' width='8' height='10' fill='white' />
		<path d='M11 12H15' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M11 14H15' stroke='#E9E9E9' strokeLinecap='round' />
		<path d='M11 16H15' stroke='#E9E9E9' strokeLinecap='round' />
	</svg>
);

export const RedoActive: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			opacity='0.5'
			d='M1.32928 8.00012C0.129285 11.2001 2.49595 14.0001 3.82928 15.0001C1.42929 9.80022 4.82928 9.16675 6.82928 9.5V12.5L13.8293 7.5L6.82928 2V5.00012C5.49595 4.66679 2.45428 5.00005 1.32928 8.00012Z'
			fill='#11B5E4'
			stroke='#11B5E4'
			strokeLinecap='round'
		/>
	</svg>
);

export const RedoInactive: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			opacity='0.5'
			d='M1.32928 8.00012C0.129285 11.2001 2.49595 14.0001 3.82928 15.0001C1.42929 9.80022 4.82928 9.16675 6.82928 9.5V12.5L13.8293 7.5L6.82928 2V5.00012C5.49595 4.66679 2.45428 5.00005 1.32928 8.00012Z'
			fill='#BEBEBE'
			stroke='#D3D3D3'
			strokeLinecap='round'
		/>
	</svg>
);

export const Save: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M0 0V15H15V3.5L12 0H0Z' fill='#656565' />
		<path d='M3 5V0H6.5V3.5H9.5V0H11V5H3Z' fill='#BEBEBE' />
		<path d='M12 15H2V7H12V15Z' fill='#BEBEBE' />
	</svg>
);

export const UndoActive: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			opacity='0.5'
			d='M13.5 8.00012C14.7 11.2001 12.3333 14.0001 11 15.0001C13.4 9.80022 10 9.16675 8 9.5V12.5L1 7.5L8 2V5.00012C9.33333 4.66679 12.375 5.00005 13.5 8.00012Z'
			fill='#11B5E4'
			stroke='#11B5E4'
			strokeLinecap='round'
		/>
	</svg>
);

export const UndoInactive: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			opacity='0.5'
			d='M13.5 8.00012C14.7 11.2001 12.3333 14.0001 11 15.0001C13.4 9.80022 10 9.16675 8 9.5V12.5L1 7.5L8 2V5.00012C9.33333 4.66679 12.375 5.00005 13.5 8.00012Z'
			fill='#BEBEBE'
			stroke='#D3D3D3'
			strokeLinecap='round'
		/>
	</svg>
);

export const PageSetup: FC<IconProps> = ({ elementStyle }) => (
	<img style={elementStyle} src={`${velocityUrl}Graphic/content/images/Page_Setup.png?_=${getScriptVersion()}`} alt={_('PageSetup')} />
);

// Selection Menu
export const Select: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 50 50'
		style={elementStyle}
		xmlSpace='preserve'>
		<g id='Layer_1_00000166677349070093005210000002214929072846989750_' style={{ display: 'none' }}>
			<g style={{ display: 'inline' }}>
				<path
					d='M40.34,31.81c0.22,0.14,0.4,0.21,0.53,0.34c2.56,2.56,5.12,5.12,7.68,7.69c0.93,0.93,0.93,1.78,0,2.71
			c-2.02,2.03-4.04,4.05-6.07,6.08c-0.9,0.9-1.76,0.89-2.67-0.01c-2.56-2.56-5.12-5.13-7.67-7.69c-0.13-0.13-0.22-0.3-0.36-0.5
			c-0.19,0.27-0.3,0.41-0.4,0.56c-1.63,2.45-3.27,4.9-4.89,7.36c-0.41,0.63-0.94,1.03-1.71,0.92c-0.79-0.11-1.19-0.64-1.42-1.39
			C20.19,37.25,17.01,26.62,13.82,16c-0.21-0.7-0.19-1.34,0.35-1.87c0.53-0.52,1.15-0.54,1.83-0.34c10.53,3.17,21.07,6.34,31.61,9.5
			c0.14,0.04,0.29,0.09,0.43,0.14c0.65,0.21,1.06,0.65,1.17,1.33c0.1,0.68-0.17,1.22-0.74,1.61c-1.13,0.76-2.26,1.52-3.4,2.27
			C43.55,29.66,42.02,30.68,40.34,31.81z M25.55,43.87c0.15-0.21,0.25-0.34,0.34-0.48c1.35-2.03,2.7-4.07,4.06-6.1
			c0.8-1.2,1.83-1.31,2.85-0.29c2.66,2.66,5.31,5.32,7.96,7.98c0.13,0.13,0.17,0.33,0.19,0.37c1.53-1.51,2.91-2.87,4.33-4.27
			c-0.11-0.1-0.26-0.22-0.39-0.35c-2.64-2.65-5.28-5.29-7.93-7.94c-0.99-0.99-0.88-2.04,0.28-2.82c2.03-1.36,4.06-2.71,6.09-4.07
			c0.15-0.1,0.29-0.2,0.51-0.36c-8.75-2.63-17.41-5.23-26.13-7.86C20.33,26.46,22.93,35.11,25.55,43.87z'
				/>
				<path
					d='M13.68,4.76c0-0.78-0.01-1.55,0-2.33c0.01-0.99,0.68-1.71,1.6-1.72s1.62,0.71,1.63,1.69c0.01,1.57,0.01,3.14,0,4.7
			c-0.01,0.98-0.71,1.7-1.62,1.7c-0.92-0.01-1.6-0.73-1.6-1.72C13.68,6.31,13.68,5.53,13.68,4.76z'
				/>
				<path
					d='M4.81,13.66c0.77,0,1.55-0.01,2.32,0c0.98,0.01,1.7,0.7,1.7,1.62c0,0.92-0.72,1.61-1.7,1.62c-1.56,0.01-3.13,0.01-4.69,0
			c-0.97-0.01-1.69-0.72-1.68-1.64c0.01-0.9,0.72-1.58,1.68-1.59C3.23,13.65,4.02,13.66,4.81,13.66z'
				/>
				<path
					d='M5.84,3.93c0.19,0.1,0.61,0.23,0.9,0.5c1.1,1.04,2.16,2.13,3.22,3.21c0.67,0.68,0.65,1.67,0,2.31
			c-0.64,0.62-1.61,0.63-2.27-0.02C6.6,8.87,5.52,7.78,4.45,6.68C3.96,6.17,3.85,5.55,4.14,4.9C4.42,4.28,4.94,3.97,5.84,3.93z'
				/>
				<path
					d='M26.63,5.79c-0.11,0.2-0.24,0.62-0.51,0.91c-1.04,1.1-2.12,2.17-3.2,3.23c-0.68,0.67-1.67,0.66-2.3,0.01
			C20,9.3,19.99,8.33,20.64,7.67c1.07-1.1,2.15-2.18,3.25-3.25c0.51-0.5,1.12-0.6,1.77-0.31C26.28,4.37,26.58,4.89,26.63,5.79z'
				/>
				<path
					d='M5.78,26.63c-0.84-0.05-1.35-0.34-1.63-0.94s-0.24-1.22,0.21-1.7c1.13-1.18,2.28-2.34,3.46-3.47
			c0.6-0.57,1.56-0.49,2.15,0.1s0.68,1.55,0.1,2.16c-1.12,1.19-2.28,2.34-3.46,3.46C6.37,26.47,5.97,26.54,5.78,26.63z'
				/>
			</g>
		</g>
		<g id='Layer_2_00000085237366118135981640000005600689404248392859_'>
			<g>
				<path
					style={{ fill: '#233B53' }}
					d='M27.34,19c0.21,0.13,0.39,0.21,0.52,0.33c2.49,2.49,16.48,16.49,18.97,18.98c0.9,0.9,0.9,1.73,0,2.64
			c-1.97,1.97-3.94,3.95-5.91,5.92c-0.87,0.88-1.71,0.87-2.6-0.01c-2.49-2.49-16.48-16.49-18.97-18.99
			c-0.13-0.13-0.21-0.29-0.35-0.49c-0.19,0.26-0.29,0.4-0.39,0.55c-1.59,2.39-3.18,4.77-4.76,7.17c-0.4,0.61-0.91,1-1.67,0.9
			c-0.77-0.11-1.16-0.63-1.38-1.35C7.73,24.3,4.63,13.96,1.53,3.62c-0.2-0.68-0.18-1.3,0.34-1.82c0.51-0.5,1.12-0.53,1.78-0.33
			c10.25,3.09,20.51,6.17,30.77,9.25c0.14,0.04,0.28,0.09,0.42,0.14c0.64,0.2,1.04,0.64,1.13,1.29c0.1,0.66-0.17,1.19-0.72,1.56
			c-1.1,0.74-2.2,1.48-3.31,2.21C30.46,16.92,28.98,17.91,27.34,19z'
				/>
			</g>
		</g>
	</svg>
);

export const Move: FC<IconProps> = ({ elementStyle }) => <i className='fa fa-lg fa-arrows' style={elementStyle}></i>;

export const ExtendZoom: FC<IconProps> = ({ elementStyle }) => <i className='fa fa-lg fa-arrows-alt' style={elementStyle}></i>;

export const Group: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 21.77 21.77'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<rect x='2.98' y='2.98' style={{ fill: '#E9E9E9', stroke: '#233B53' }} width='9.5' height='9.5' />
			<rect x='9.28' y='9.28' style={{ fill: '#E9E9E9', stroke: '#233B53' }} width='9.5' height='9.5' />
			<rect x='0.38' y='0.38' style={{ fill: '#233B53' }} width='3.15' height='3.15' />
			<rect x='0.38' y='18.23' style={{ fill: '#233B53' }} width='3.15' height='3.15' />
			<rect x='18.23' y='0.38' style={{ fill: '#233B53' }} width='3.15' height='3.15' />
			<rect x='18.23' y='18.23' style={{ fill: '#233B53' }} width='3.15' height='3.15' />
		</g>
	</svg>
);

export const Ungroup: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		style={elementStyle}
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 19 19'
		xmlSpace='preserve'>
		<polyline fill='none' points='7.9,11.1 1.6,11.1 1.6,1.6 11.1,1.6 11.1,7.8 ' stroke='#233B53' />
		<rect x='7.9' y='7.9' fill='none' width='9.5' height='9.5' stroke='#233B53' />
		<rect x='10' fill='#233B53' width='3' height='3' />
		<rect fill='#233B53' width='3' height='3' />
		<rect y='10' fill='#233B53' width='3' height='3' />
		<rect x='6' y='16' fill='#233B53' width='3' height='3' />
		<rect x='16' y='16' fill='#233B53' width='3' height='3' />
		<rect x='16' y='6' fill='#233B53' width='3' height='3' />
		<rect x='6' y='6' fill='#233B53' width='3' height='3' />
	</svg>
);

export const Rotate: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 20 20'
		style={elementStyle}
		xmlSpace='preserve'>
		<path
			d='M17.63,3.63c0.7-0.39,1.39-0.77,2.07-1.14c0,2.62,0,5.21,0,7.91c-2.33-1.39-4.55-2.71-6.85-4.08
	c0.89-0.5,1.72-0.97,2.56-1.45c-1.73-1.96-4.99-2.96-8.04-1.76c-3,1.18-4.89,4.25-4.64,7.51c0.25,3.17,2.63,5.89,5.77,6.6
	c3.16,0.71,6.97-0.74,8.54-4.53c0.72,0.28,1.44,0.56,2.17,0.84c-0.82,2.67-3.85,5.76-8,6.22C6.59,20.26,2.4,17.5,0.9,13.38
	c-1.55-4.25-0.02-8.93,3.66-11.5C8.04-0.55,13.86-0.69,17.63,3.63z'
		/>
	</svg>
);

export const Resize: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Resize.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('Resize')} style={elementStyle} />;
};

export const FlipVertical: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 27.68 23'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<path d='M12.3,19.76V2.09L1.17,19.76H12.3z' style={{ fill: '#BEBEBE' }} />
			<path d='M15.37,19.76V2.09l11.13,17.66H15.37z' style={{ fill: '#233B53' }} />
			<path d='M13.84,0.56v21.89' style={{ fill: 'none', stroke: '#656565', strokeLinecap: 'round', strokeLinejoin: 'round' }} />
		</g>
	</svg>
);

export const FlipHorizontal: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 26 31.23'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<path d='M21.26,17.15H3.59l17.66,11.13V17.15z' style={{ fill: '#BEBEBE' }} />
			<path d='M21.26,14.08H3.59L21.26,2.94V14.08z' style={{ fill: '#233B53' }} />
			<path d='M2.06,15.61h21.89' style={{ fill: 'none', stroke: '#656565', strokeLinecap: 'round', strokeLinejoin: 'round' }} />
		</g>
	</svg>
);

export const BringForward: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 21.59 21.59'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<rect x='8.79' y='8.79' width='12' height='12' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
			<rect x='0.79' y='0.79' width='13' height='13' style={{ fill: '#E9E9E9', stroke: '#233B53' }} />
		</g>
	</svg>
);

export const SendBackward: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 21.59 21.59'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<rect x='7.79' y='7.79' width='13' height='13' style={{ fill: '#E9E9E9', stroke: '#233B53' }} />
			<rect x='0.79' y='0.79' width='12' height='12' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
		</g>
	</svg>
);

export const BringToFront: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 21.59 21.59'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<rect x='0.79' y='0.79' width='9' height='9' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
			<rect x='11.79' y='11.79' width='9' height='9' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
			<rect x='5.79' y='5.79' width='10' height='10' style={{ fill: '#E9E9E9', stroke: '#233B53' }} />
		</g>
	</svg>
);

export const SendToBack: FC<IconProps> = ({ elementStyle }) => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 21.59 21.59'
		style={elementStyle}
		xmlSpace='preserve'>
		<g>
			<rect x='5.79' y='5.79' className='st0' width='10' height='10' style={{ fill: '#E9E9E9', stroke: '#233B53' }} />
			<rect x='0.79' y='0.79' className='st1' width='9' height='9' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
			<rect x='11.79' y='11.79' className='st1' width='9' height='9' style={{ fill: '#BEBEBE', stroke: '#BEBEBE' }} />
		</g>
	</svg>
);

// Text Menu
export const AddText: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='14' height='27' viewBox='0 0 14 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M12.46 8.66H11.86L10.92 6.36L7.7 6.32V18.34L9.56 18.52V19H3.18V18.52L5.04 18.34V6.32L1.82 6.36L0.88 8.66H0.3V5.64L6.38 5.6L12.46 5.64V8.66Z'
			fill='#233B53'
		/>
		<circle cx='10.8349' cy='17.3565' r='3.16522' fill='#406080' />
		<path d='M10.8347 15.6522V19.0609' stroke='white' strokeLinecap='round' />
		<path d='M9.13037 17.3571L12.5391 17.3571' stroke='white' strokeLinecap='round' />
	</svg>
);

export const AddParagraph: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='15' height='13' fill='#E9E9E9' stroke='#233B53' />
		<path
			d='M8.23 3.83H7.93L7.46 2.68L5.85 2.66V8.67L6.78 8.76V9H3.59V8.76L4.52 8.67V2.66L2.91 2.68L2.44 3.83H2.15V2.32L5.19 2.3L8.23 2.32V3.83Z'
			fill='#233B53'
		/>
		<circle cx='14.1652' cy='12.1652' r='3.16522' fill='#406080' />
		<path d='M14.165 10.4609V13.8696' stroke='white' strokeLinecap='round' />
		<path d='M12.4607 12.166L15.8694 12.166' stroke='white' strokeLinecap='round' />
	</svg>
);

export const Bold: FC<IconProps> = ({ elementStyle }) => (
	<span style={elementStyle}>
		<svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
			<path
				d='M10.1016 10.2559H7.91016L7.89844 9.04883H9.73828C10.0625 9.04883 10.3281 9.00781 10.5352 8.92578C10.7422 8.83984 10.8965 8.7168 10.998 8.55664C11.1035 8.39258 11.1562 8.19336 11.1562 7.95898C11.1562 7.69336 11.1055 7.47852 11.0039 7.31445C10.9062 7.15039 10.752 7.03125 10.541 6.95703C10.334 6.88281 10.0664 6.8457 9.73828 6.8457H8.51953V14H6.76172V5.46875H9.73828C10.2344 5.46875 10.6777 5.51562 11.0684 5.60938C11.4629 5.70312 11.7969 5.8457 12.0703 6.03711C12.3438 6.22852 12.5527 6.4707 12.6973 6.76367C12.8418 7.05273 12.9141 7.39648 12.9141 7.79492C12.9141 8.14648 12.834 8.4707 12.6738 8.76758C12.5176 9.06445 12.2695 9.30664 11.9297 9.49414C11.5938 9.68164 11.1543 9.78516 10.6113 9.80469L10.1016 10.2559ZM10.0254 14H7.42969L8.11523 12.6289H10.0254C10.334 12.6289 10.5859 12.5801 10.7812 12.4824C10.9766 12.3809 11.1211 12.2441 11.2148 12.0723C11.3086 11.9004 11.3555 11.7031 11.3555 11.4805C11.3555 11.2305 11.3125 11.0137 11.2266 10.8301C11.1445 10.6465 11.0117 10.5059 10.8281 10.4082C10.6445 10.3066 10.4023 10.2559 10.1016 10.2559H8.4082L8.41992 9.04883H10.5293L10.9336 9.52344C11.4531 9.51562 11.8711 9.60742 12.1875 9.79883C12.5078 9.98633 12.7402 10.2305 12.8848 10.5312C13.0332 10.832 13.1074 11.1543 13.1074 11.498C13.1074 12.0449 12.9883 12.5059 12.75 12.8809C12.5117 13.252 12.1621 13.5312 11.7012 13.7188C11.2441 13.9062 10.6855 14 10.0254 14Z'
				fill='#233B53'
			/>
		</svg>
	</span>
);

export const Italic: FC<IconProps> = ({ elementStyle }) => (
	<span style={elementStyle}>
		<svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
			<path d='M11.0117 5.46875L9.5293 14H8.42773L9.91016 5.46875H11.0117Z' fill='#233B53' />
		</svg>
	</span>
);

export const Underline: FC<IconProps> = ({ elementStyle }) => (
	<span style={elementStyle}>
		<svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
			<path
				d='M11.6543 5.46875H13.1191V11.1699C13.1191 11.8184 12.9785 12.3613 12.6973 12.7988C12.416 13.2363 12.0332 13.5664 11.5488 13.7891C11.0684 14.0078 10.5312 14.1172 9.9375 14.1172C9.32422 14.1172 8.77734 14.0078 8.29688 13.7891C7.81641 13.5664 7.4375 13.2363 7.16016 12.7988C6.88672 12.3613 6.75 11.8184 6.75 11.1699V5.46875H8.21484V11.1699C8.21484 11.5801 8.28516 11.918 8.42578 12.1836C8.56641 12.4453 8.76562 12.6387 9.02344 12.7637C9.28125 12.8887 9.58594 12.9512 9.9375 12.9512C10.2891 12.9512 10.5918 12.8887 10.8457 12.7637C11.1035 12.6387 11.3027 12.4453 11.4434 12.1836C11.584 11.918 11.6543 11.5801 11.6543 11.1699V5.46875Z'
				fill='#233B53'
			/>
			<path d='M6 15.1719H13.8516V15.7578H6V15.1719Z' fill='#233B53' />
		</svg>
	</span>
);

export const AlignLeft: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
		<line x1='15.5' y1='5.5' x2='4.5' y2='5.5' stroke='black' strokeLinecap='round' />
		<line x1='10.5' y1='8.5' x2='4.5' y2='8.5' stroke='black' strokeLinecap='round' />
		<line x1='10.5' y1='11.5' x2='4.5' y2='11.5' stroke='black' strokeLinecap='round' />
		<line x1='10.5' y1='14.5' x2='4.5' y2='14.5' stroke='black' strokeLinecap='round' />
	</svg>
);

export const AlignCenter: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
		<line x1='15.5' y1='5.5' x2='4.5' y2='5.5' stroke='black' strokeLinecap='round' />
		<line x1='12.5' y1='8.5' x2='6.5' y2='8.5' stroke='black' strokeLinecap='round' />
		<line x1='12.5' y1='11.5' x2='6.5' y2='11.5' stroke='black' strokeLinecap='round' />
		<line x1='12.5' y1='14.5' x2='6.5' y2='14.5' stroke='black' strokeLinecap='round' />
	</svg>
);

export const AlignRight: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='19' height='19' fill='#E9E9E9' stroke='#D1D1D1' />
		<line x1='15.5' y1='5.5' x2='4.5' y2='5.5' stroke='black' strokeLinecap='round' />
		<line x1='15.5' y1='8.5' x2='9.5' y2='8.5' stroke='black' strokeLinecap='round' />
		<line x1='15.5' y1='11.5' x2='9.5' y2='11.5' stroke='black' strokeLinecap='round' />
		<line x1='15.5' y1='14.5' x2='9.5' y2='14.5' stroke='black' strokeLinecap='round' />
	</svg>
);

export const FontColor: FC<IconProps> = ({ elementStyle }) => (
	<span style={elementStyle}>
		<svg viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect y='15.9399' width='18' height='2' fill={elementStyle?.color || '#51DAE6'} />
			<path
				d='M8.93555 4.74902L6.22852 13H4.04785L7.74609 3.04688H9.13379L8.93555 4.74902ZM11.1846 13L8.4707 4.74902L8.25195 3.04688H9.65332L13.3721 13H11.1846ZM11.0615 9.29492V10.9014H5.80469V9.29492H11.0615Z'
				fill='#233B53'
			/>
		</svg>
	</span>
);

export const SearchText: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='16' height='18' viewBox='0 0 16 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M11.8175 16.8409L8.85934 13.623C9.61995 12.6773 10.0367 11.4874 10.0367 10.2487C10.0367 7.35463 7.78542 5 5.01835 5C2.25127 5 0 7.35463 0 10.2487C0 13.1429 2.25127 15.4975 5.01835 15.4975C6.05714 15.4975 7.04707 15.1698 7.89342 14.5477L10.8741 17.7901C10.9987 17.9254 11.1663 18 11.3458 18C11.5158 18 11.677 17.9322 11.7994 17.809C12.0595 17.5472 12.0678 17.1132 11.8175 16.8409ZM5.01834 6.36924C7.06365 6.36924 8.72756 8.10954 8.72756 10.2487C8.72756 12.388 7.06365 14.1283 5.01835 14.1283C2.97304 14.1283 1.30913 12.388 1.30913 10.2487C1.30913 8.10954 2.97304 6.36924 5.01834 6.36924Z'
			fill='#233B53'
		/>
		<path
			d='M13.984 3.864H13.744L13.368 2.944L12.08 2.928V7.736L12.824 7.808V8H10.272V7.808L11.016 7.736V2.928L9.728 2.944L9.352 3.864H9.12V2.656L11.552 2.64L13.984 2.656V3.864Z'
			fill='#233B53'
		/>
	</svg>
);

// Drawing
export const RedlineFreeHand: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M0.999937 5.49934C2.99994 2.666 6.89994 -1.80066 6.49994 2.99934C6.09994 7.79934 2.99995 10.2138 1.49992 12.9995C-0.000122011 15.7852 -0.400062 20.0995 7.99994 16.4995C16.3999 12.8995 17.8332 7.66606 17.4999 5.49934'
			stroke='#A53D3D'
			strokeLinecap='round'
		/>
	</svg>
);

export const RedlineRectangle: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='23' height='15' fill='#E9E9E9' stroke='#A53D3D' />
	</svg>
);

export const RedlineFilledRectangle: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='23' height='15' fill='#A53D3D' fillOpacity='0.36' stroke='#A53D3D' />
	</svg>
);

export const RedlineCircle: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='8' cy='8' r='7.5' fill='#E9E9E9' stroke='#A53D3D' />
	</svg>
);

export const RedlineFilledCircle: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='8' cy='8' r='7.5' fill='#D1ABAB' stroke='#A53D3D' />
	</svg>
);

export const RedlineArrow: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='21' height='17' viewBox='0 0 21 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M0.5 0.5L20 0.5V12H8' stroke='#A53D3D' strokeLinecap='round' />
		<path d='M-2.40413e-07 11.5L8.25 6.73686L8.25 16.2631L-2.40413e-07 11.5Z' fill='#A53D3D' />
	</svg>
);

export const MonitorZone: FC<IconProps> = ({ elementStyle }) => (
	<svg style={elementStyle} width='21' height='17' viewBox='0 0 21 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='2.5' y='2.5' width='16' height='12' fill='#FAD723' fillOpacity='0.36' stroke='#F5B400' />
		<rect width='4' height='4' fill='#F5B400' />
		<rect y='13' width='4' height='4' fill='#F5B400' />
		<rect x='17' width='4' height='4' fill='#F5B400' />
		<rect x='17' y='13' width='4' height='4' fill='#F5B400' />
	</svg>
);

export const Pin: FC<IconProps> = ({ elementStyle }) => (
	<svg
		style={elementStyle}
		height={17}
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		width={21}
		version='1.1'
		viewBox='0 0 17 17'
		xmlSpace='preserve'>
		<path
			fill='#A53D3D'
			d='M14,5.9C14,2.6,11.4,0,8.2,0C4.9,0,2.3,2.6,2.3,5.9c0,0.9,0.2,1.8,0.6,2.6h0L8.2,17l5.2-8.5h0
	C13.8,7.7,14,6.8,14,5.9z M8.2,3.5c1.3,0,2.3,1.1,2.3,2.3c0,1.3-1.1,2.3-2.3,2.3c-1.3,0-2.3-1.1-2.3-2.3C5.8,4.6,6.9,3.5,8.2,3.5z'
		/>
	</svg>
);

export const LineColor: FC<IconProps> = ({ elementStyle }) => (
	<svg
		style={elementStyle}
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 17 17'
		xmlSpace='preserve'>
		<g>
			<path
				d='M16.6,3.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.2,0.4-0.3,0.5c-0.2,0.2-0.4,0.4-0.6,0.6c-1.1-1.1-2.2-2.2-3.4-3.4
		c0.3-0.3,0.6-0.6,0.9-0.8c0.5-0.4,1.2-0.3,1.7,0.1c0.5,0.5,1,1,1.5,1.5c0.2,0.2,0.3,0.5,0.4,0.8C16.6,3.1,16.6,3.2,16.6,3.3z'
			/>
			<path
				d='M0.5,15.9c0.4-1.2,0.8-2.3,1.2-3.5c0-0.1,0-0.1,0.1-0.1c1,1,2,2,3.1,3.1c-1.3,0.4-2.5,0.8-3.8,1.3c0,0-0.1,0-0.1,0l-0.4,0
		v-0.4L0.5,15.9z'
			/>
			<path d='M10.2,3.6C10.6,4,13,6.4,13.5,6.9c-2.6,2.6-5.3,5.3-7.9,7.9c-0.4-0.4-2.9-2.9-3.3-3.3C4.9,8.8,7.5,6.2,10.2,3.6z' />
			<path d='M14.8,5.5c-0.2,0.2-0.4,0.4-0.6,0.6C13.1,5,12,3.9,10.9,2.8c0.2-0.2,0.4-0.4,0.6-0.6C12.6,3.3,13.7,4.4,14.8,5.5z' />
		</g>
	</svg>
);

export const PaintBucket: FC<IconProps> = ({ elementStyle }) => (
	<svg
		style={elementStyle}
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 17 17'
		xmlSpace='preserve'>
		<g>
			<path
				fill='none'
				stroke='#020202'
				strokeWidth={2}
				strokeMiterlimit={10}
				d='M4.6,1.4l8.6,8.6l-4.8,4.8c0,0-1.3,1.5-2.4,0.4s-4.7-4.7-4.7-4.7S0.8,9.5,2,8.4l4.8-4.8'
			/>
			<polygon points='1.2,9.7 12.6,9.8 6.9,15.4 	' />
			<path d='M14.6,15.6c-1.1,0-1.7-0.9-1.6-2.2s1.7-2.9,1.7-2.9s1.6,1.6,1.6,2.9S15.6,15.6,14.6,15.6z' />
		</g>
	</svg>
);

export const DeleteRedline: FC<IconProps> = ({ elementStyle }) => (
	<svg
		style={elementStyle}
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 18 18'
		xmlSpace='preserve'>
		<rect fill='none' width='18' height='18' />
		<g>
			<path fill='#C5C9D7' d='M3.5,6h10.8l-0.6,8.9c0,0.7-0.6,1.2-1.3,1.2H5.6c-0.7,0-1.3-0.5-1.3-1.2L3.5,6z' />
			<path
				fill='#767981'
				d='M14.2,6H3.8C3.1,6,2.5,5.5,2.5,4.8v0c0-0.7,0.5-1.2,1.2-1.2h10.5c0.7,0,1.2,0.5,1.2,1.2v0
		C15.5,5.5,14.9,6,14.2,6z'
			/>
			<g>
				<path fill='#53565B' d='M6,3.6V2.8c0,0,0.2-1,1.2-1s1.8,0,1.8,0v0.9H7.3c0,0-0.5,0-0.5,0.4v0.5H6z' />
				<path fill='#53565B' d='M11.9,3.6V2.8c0,0-0.2-1-1.2-1S9,1.8,9,1.8v0.9h1.7c0,0,0.5,0,0.5,0.4v0.5H11.9z' />
			</g>
			<g>
				<path
					fill='#A2A7B2'
					d='M9,14.7L9,14.7c-0.2,0-0.4-0.2-0.4-0.4V7.1c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.2,0.4,0.4v7.2
			C9.4,14.5,9.2,14.7,9,14.7z'
				/>
				<path
					fill='#A2A7B2'
					d='M11.2,14.7L11.2,14.7c-0.2,0-0.4-0.2-0.4-0.4L11.1,7c0-0.2,0.2-0.4,0.4-0.4h0c0.2,0,0.4,0.2,0.4,0.4l-0.3,7.2
			C11.6,14.5,11.4,14.7,11.2,14.7z'
				/>
				<path
					fill='#A2A7B2'
					d='M6.8,14.7L6.8,14.7c0.2,0,0.4-0.2,0.4-0.4L6.8,7c0-0.2-0.2-0.4-0.4-0.4h0C6.2,6.7,6,6.8,6,7.1l0.3,7.2
			C6.3,14.5,6.5,14.7,6.8,14.7z'
				/>
			</g>
		</g>
		<g>
			<path
				fill='#A63D3E'
				d='M16.9,9.4c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.4c-0.7-0.7-1.3-1.3-2-2
		c0.2-0.2,0.4-0.4,0.5-0.5c0.3-0.2,0.7-0.2,1,0.1c0.3,0.3,0.6,0.6,0.9,0.9C16.9,8.8,16.9,9,17,9.2C16.9,9.2,16.9,9.3,16.9,9.4z'
			/>
			<path
				fill='#A63D3E'
				d='M7.2,16.9c0.2-0.7,0.5-1.4,0.7-2.1c0-0.1,0-0.1,0.1-0.1c0.6,0.6,1.2,1.2,1.9,1.9c-0.8,0.2-1.5,0.5-2.3,0.8H7.5
		H7.3v-0.2L7.2,16.9z'
			/>
			<path fill='#A63D3E' d='M13.1,9.5c0.2,0.2,1.7,1.7,2,2c-1.6,1.6-3.2,3.2-4.7,4.7c-0.2-0.2-1.7-1.7-2-2C9.9,12.7,11.5,11.1,13.1,9.5z' />
			<path
				fill='#A63D3E'
				d='M15.8,10.7c-0.1,0.1-0.2,0.2-0.4,0.4c-0.7-0.7-1.3-1.3-2-2c0.1-0.1,0.2-0.2,0.4-0.4
		C14.5,9.4,15.2,10,15.8,10.7z'
			/>
		</g>
	</svg>
);

// View
export const View: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Show_Hide-Menus-config.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('View')} style={elementStyle} />;
};

export const Devices: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Devices.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('Devices')} style={elementStyle} />;
};

export const BirdEye: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Bird_Eye.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('BirdEye')} style={elementStyle} />;
};

export const QuickAccess: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Quick_Access.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('QuickAccess')} style={elementStyle} />;
};

export const ObjectProperties: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Object_Properties.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('ObjectProperties')} style={elementStyle} />;
};

export const PlottedDevices: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Plotted_Devices.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('PlottedDevices')} style={elementStyle} />;
};

export const AlarmQueue: FC<IconProps> = ({ elementStyle }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Menus_Alarm_Queue.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('AlarmQueue')} style={elementStyle} />;
};

// AlarmQueue

export const Acknowledge: FC<IconProps> = ({ elementStyle, title }) => {
	const svgPath = `${velocityUrl}graphic/content/images/Alarm_Acknowledge.svg?_=${getScriptVersion()}`;
	return <img src={svgPath} alt={_('Acknowledge')} title={title} style={elementStyle} />;
};
